module.exports = __webpack_public_path__ + "img/cat1.882833f1.svg";